import React from 'react';

//import * as Scroll from 'react-scroll';
//import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';

import { Element } from 'react-scroll';


import ImageArtwork from './ImageArtwork';
import ImgNavigator from './ImgNavigator';
import LoadingBar from './LoadingBar';
import './theme.css';

export default class Home extends React.Component {




  constructor(props)
  {
    super(props);
    this.state = {titleSize: 0, Imgs: undefined};
    this.OnImageLoaded = this.OnImageLoaded.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.ShrinkTitle = this.ShrinkTitle.bind(this);

    this.loadedcnt=0;

    let ctx = this;
    this.props.fl.content.get('artworks',
      //{fields: [ 'name', 'description'],}
    )
    .then(rs => {
      ctx.data = [];
      Object.keys(rs).forEach(iprop => {ctx.data.push(rs[iprop]);});
      ctx.data.sort( () => Math.random() - 0.5);
      ctx.imgurls = ctx.data.map((d) => d.imgUrl);
      ctx.loadImage(ctx.loadedcnt++);
    })
    .catch(err => console.error(err));

  }

  OnImageLoaded()
  {
    if(this.loadedcnt===1)//title shrinks when first image loaded
      this.ShrinkTitle(null);
    if(this.loadedcnt < this.data.length)//there's more to load
      this.loadImage(this.loadedcnt++);
  }

  loadImage(i)
  {
    let tmpImgs = [];
    if(this.state.Imgs)
      tmpImgs = this.state.Imgs;
    tmpImgs.push(
      <Element name={"scrollref"+i} key={i}>
        <ImageArtwork key={this.data[i].id}
                   SeqId={i}
                   ImgUrl={this.data[i].imgUrl}
                   SiteUrl1={this.data[i].siteUrl1}
                   SiteUrl2={this.data[i].siteUrl2}
                   OnLoaded={this.OnImageLoaded}
                   />
      </Element>
    );

    let tmpUrls = [];
    if(this.state.Urls)
      tmpUrls = this.state.Urls;
    tmpUrls.push(this.data[i].imgUrl);

    this.setState({Imgs: tmpImgs, Urls: tmpUrls});

  }

  ShrinkTitle(e) {
    //e.preventDefault()
    let ctx = this;
    setTimeout(function() {
      ctx.setState({
        titleSize: 1
      });
    }, 1000);
  }

  render() {
    return (
      <div>
        <div className={this.state.titleSize?"cimkicsi":"cimnagy"}>
          <a href="\">ART OF BEZO97</a>
        </div>
        {!this.state.titleSize &&
          <LoadingBar/>
        }
        {this.state.Imgs &&
          <div id="kepkeret" style={{userSelect: 'none'}}>
            {this.state.Imgs}
          </div>
        }
        {this.state.Imgs &&
          <ImgNavigator imgurls={this.state.Urls}/>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/Home.js